const expandPainelButtonFormActions = {
  more: 'Ver más',
  less: 'Ver menos'
};

export default expandPainelButtonFormActions;
